// @flow
import {useTranslation} from 'gatsby-plugin-react-i18next';
import React, {useEffect} from 'react';

//import supabase from '_client/supabase';
import ComingSoonSection from '_components/ComingSoonSection';
import AboutSection from '_components/Homepage/About';
import ApexSection from '_components/Homepage/Apex';
import ColdPlungeSection from '_components/Homepage/ColdPlunge';
import EthosSection from '_components/Homepage/Ethos';
import FAQSection from '_components/Homepage/FAQ';
import FloatTankSection from '_components/Homepage/FloatTank';
import HeroSection from '_components/Homepage/Hero';
import InfraredSection from '_components/Homepage/Infrared';
import LocationSection from '_components/Homepage/Location';
import Layout from '_components/Layout/simple';
import useAnalytics, {event} from '_hooks/useAnalytics';
import useBreakpoint from '_hooks/useBreakpoint';

const Home = (): React$Node => {
  const {t} = useTranslation();
  const {track} = useAnalytics();

  useEffect(() => {
    track({
      group: event.group.Home,
      action: event.action.Viewed,
    });
  }, [track]);

  useEffect(() => {
    (async () => {
      /*
      const {data: session} = await supabase.auth.getSessionFromUrl();
      if (!session) {
        return;
      }

      const redirectUrl = `${
        process.env.GATSBY_SUPABASE_REDIRECT_LINK ?? 'https://spheregym.test-app.link/login'
      }?token=${session.refresh_token}`;

      window.location.replace(redirectUrl);
       */
    })();
  }, []);

  return (
    <Layout floatingNavbar={false} inverseFooter>
      <ComingSoonSection />
      {/* 
      <HeroSection />
      <AboutSection />
      <ApexSection />
      <InfraredSection />
      <ColdPlungeSection />
      <FloatTankSection />
      <EthosSection />
      <FAQSection />
      <LocationSection /> */}
    </Layout>
  );
};

export default Home;
